import { format } from 'date-fns';

import { StudentActivityListItem } from './singleStudent.types';

export const groupActivitiesByMonth = (activities: StudentActivityListItem[]) => {
  const groupedActivities = activities.reduce((acc, activity) => {
    const month = format(new Date(activity.date), 'MMMM yyyy');

    if (!acc[month]) {
      acc[month] = [];
    }

    acc[month].push(activity);
    return acc;
  }, {} as Record<string, StudentActivityListItem[]>);

  return Object.entries(groupedActivities)
    .map(([month, activities]) => ({
      month,
      activities: activities.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
      ),
    }))
    .sort(
      (a, b) => new Date(b.activities[0].date).getTime() - new Date(a.activities[0].date).getTime(),
    );
};
